import React from 'react'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'

const InfoPopup = (props) => {
  const modalStyle = {
    borderBottom: "none",
    padding: "2rem 2rem 0 0"
  }

  const modalBodyStyle = {
    marginTop: "1.5rem"
  }

  const bodyStyle = {
    margin: "1rem 2rem !important",
    textAlign: "center",
    padding: "0 2rem"
  }

  return (
    <Modal isOpen={props.showPopUpText} toggle={props.toggleInfoPopup} centered>
    <ModalHeader style={modalStyle} toggle={props.toggleInfoPopup}></ModalHeader>
      <ModalBody className={props.nifty ? '' : 'text-center'} style={modalBodyStyle}>
        <div style={bodyStyle}>
          {props?.excedeImg ? <img src={props?.excedeImg} alt="excedeImg" /> : null}
          {/* <p className='font-size-18 text-muted'>{props.text}</p> */}
          <p className="font-size-18 text-muted" dangerouslySetInnerHTML={{__html: props.text}} />
        </div>
        {props?.img &&
        <img src={props?.img} alt="ipoLimit" />}

        {props?.button && 
        <Button onClick={props?.toggleInfoPopup}>Click on continue</Button> 
        }
      </ModalBody>
    </Modal>
  )
}

export default InfoPopup